/* eslint-disable camelcase */
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert2';
import shortid from 'shortid';
import { spmfcloudFunctionUrl, updateObject } from '../../../actions/salesforces';
import { encryptQuery } from '../../../utils/common';
import { fetchQueryData, sendMails } from '../../../utils/sf-request';
// import EmailTemplate from './EmailTemplate';


export default null;

const emailData = {
    title: 'Welcome Email',
    body: 'Thank you for signing up!',
    items: ['Benefit 1', 'Benefit 2', 'Benefit 3'],
  };

export function applicationColumns(user, deleteApplication = () => {}) {
    const { loggedInUser } = this.props.user;
    const { checkedIds } = this.state;
    return [{
        Header: loggedInUser.Partner_Authority__c !== null ? <input type="checkbox" onChange={this.toggleCheckedList} /> : '#',
        accessor: 'Id',

        Cell: (propsCol) => {
            const filter = loggedInUser.Partner_Authority__c === 'Approver' ? 'verified by partner' : 'received';
            return (propsCol.row.Application_Status__c.toLowerCase() === filter ?
                <input type="checkbox" checked={checkedIds.indexOf(propsCol.value) > -1} value={propsCol.value} onChange={this.toggleCheckedList} /> : null);
        },
        filterable: false,
        width: 40,
    }, {
        Header: 'Application No',
        accessor: 'Application__r',
        Cell: propsCol => propsCol.value.Name,
        filterMethod: (filter, row) => {
            if (row.Application__r.Name.startsWith(filter.value)) return row;
        },
        width: 120
    }, {
        id: 'ApplicantName',
        Header: 'Applicant Name',
        accessor: a => a.Application__r.Applicant_Name__c,
    }, {
        Header: 'Beneficiary Name',
        accessor: 'Full_Name__c',
    }, {
        id: 'DateSubmitted',
        Header: 'Date Submitted',
        accessor: b => b.Application__r.Date_of_Application__c,
        Cell: propsCol => moment(propsCol.value).format('DD-MMM-YYYY'),
        filterMethod: (filter, row) => {
            if (moment(row.Application__r.Date_of_Application__c).format('DD-MMM-YYYY').indexOf(filter.value) !== -1) return row;
        },
        width: 100,
    }, {
        Header: 'Status',
        accessor: 'Application_Status__c',
        Filter: ({ filter, onChange }) => {
            return (
                <select
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ''}
                >
                    <option value="">All</option>
                    <option value="Draft">Draft</option>
                    {this.props.appStatusList.map(status => (
                        <option key={shortid.generate()} value={status.value}>{status.label}</option>
                    ))}
                </select>
            );
        },
        width: 150
    }, {
        Header: 'Criteria Indicator',
        accessor: 'Criteria_Indicator_2__c',
        filterable: false,
        width: 60,
        Cell: (propsCol) => {
            if (propsCol.value) {
                return (<i className="fa fa-circle" style={{ color: 'red', textAlign: 'center' }} />);
            }
            return (<i className="fa fa-circle" style={{ color: 'green', textAlign: 'center' }} />);
        },
    }, {
        Header: 'Action',
        accessor: 'Application__c',
        filterable: false,
        Cell: (propsCol) => {
            if (propsCol.value.slice(0, 5) === 'draft') {
                return (
                    <div className="btn-group">
                        <Link
                            to={`/portal/registration-v2?draftId=${propsCol.value.substr(6)}`}
                            className="btn btn-sm btn-default btn-fill"
                        >
                            <i className="fa fa-folder-open" /> Continue
                        </Link>
                        <button
                            className="btn btn-default btn-sm"
                            onClick={async () => {
                                try {
                                    // Ask for confirmation first
                                    const willDelete = await swal({
                                        title: 'Delete this draft?',
                                        text: 'Once deleted, you will not be able to recover it',
                                        type: 'warning',
                                        confirmButtonText: 'Yes, Delete it',
                                        showCancelButton: true,
                                        confirmButtonColor: '#f00',
                                    });

                                    if (willDelete.value) {
                                        this.setState({ loading: true });
                                        // Delete the draft...
                                        const response = await fetch(`${spmfcloudFunctionUrl}/draft/applications/delete/${propsCol.value.slice(6)}`, {
                                            mode: 'cors',
                                            cache: 'no-cache',
                                            method: 'POST',
                                            headers: {
                                                'hash-token': this.props.user.siteToken.hash,
                                            },
                                        });

                                        const json = await response.json();
                                        if (!response.ok) throw new Error(json.message);

                                        // And refresh the list
                                        await this.getApplicationList(true);
                                    }
                                } catch (err) {
                                    swal({
                                        text: `Failed to delete application. ${err.message}`,
                                        title: 'Deleting Application Draft',
                                        icon: 'error',
                                        dangerMode: true,
                                    });
                                } finally {
                                    this.setState({ loading: false });
                                }
                            }}
                        >
                            <i className="fa fa-remove" /> Delete
                        </button>
                    </div>
                );
            }

            const buttonGroup = (
                <div className="btn-group">
                    <Link
                        to={`/portal/application/${propsCol.value}`}
                        className="btn btn-sm btn-default btn-fill"
                        key={shortid.generate()}
                    >
                        <i className="fa fa-eye" /> View
                    </Link>
                    {
                        propsCol.original.Application_Status__c === 'Received' ? (
                            <button
                                onClick={() => {
                                    swal.fire({
                                        title: 'Are you sure?',
                                        text: "You won't be able to revert this!",
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        confirmButtonText: 'Yes, delete it!',
                                        }).then(async(result) => {
                                        if (result.value) {
                                            const personData = propsCol.original
                                            deleteApplication({
                                                status: 'Deleted By Partner',
                                                applicationId: personData.Application__c,
                                                // beneficiaryId: personData.Id,
                                                // accountId: personData.Applying_to__c,
                                                callback: () => {
                                                    swal.fire(
                                                    'Deleted!',
                                                    'Application has been deleted.',
                                                    'success',
                                                    )
                                                }
                                                    
                                            })
                                        }
                                    });
                                }}
                                className="btn btn-sm btn-default"
                                key={shortid.generate()}
                            >
                                <i className="fa fa-trash" /> Delete
                            </button>
                        ) : ''
                    }
                    <button
                        href={null}
                        key={shortid.generate()}
                        className="btn btn-default btn-sm"
                        onClick={(e) => {
                            e.preventDefault();
                            const form = document.createElement('form');
                            form.setAttribute('method', 'post');
                            form.setAttribute('target', '_blank');
                            form.setAttribute('action', `${spmfcloudFunctionUrl}/application-attachment/${propsCol.value}`);
                            const token = document.createElement('input');
                            token.setAttribute('type', 'hidden');
                            token.setAttribute('value', user.siteToken.hash);
                            token.setAttribute('name', 'token');
                            form.appendChild(token);
                            document.getElementById('hidden').append(form);
                            form.submit();
                            // otherWindow.location = `${spmfcloudFunctionUrl}/application-attachment/${propsCol.value}?token=${user.siteToken.hash}`;
                        }}
                    >
                        <i className="fa fa-download" /> Download
                    </button>
                </div>
            );

            return buttonGroup;
        },
    }];
}

async function getApplicationDraftList() {
    const json = await fetch(`${spmfcloudFunctionUrl}/draft/applications?partnerId=${this.props.user.loggedInUser.AccountId}`, {
        headers: {
            'hash-token': this.props.user.siteToken.hash,
        },
        mode: 'cors',
        method: 'GET',

    }).then(async (response) => {
        const json_ = await response.json();
        if (!response.ok) throw new Error(json_.message);
        return json_;
    });

    const result = [];

    for (let a = 0; a < json.data.length; a++) {
        const {
            tab2,
            tab3,
            // tab4,
            _id,
            modifiedAt,
        } = json.data[a];

        result.push({
            Application_Status__c: 'Draft',
            Application__c: `draft/${_id}`,
            Application__r: {
                Applicant_Name__c: tab2.Full_Name__c,
                Date_of_Application__c: modifiedAt,
                Name: 'NA',
            },
            Criteria_Indicator_2__c: false,
            Full_Name__c: tab3 && tab3[0] ? tab3[0].Full_Name__c : '',
            Id: '',
        });
    }


    return result;
}

/**
 * This function need to be bind with main component
 * return Promise JSON
 */
export async function getApplicationList(bypass = false) {
    if (this === undefined) return;
    if (this.state.loading && (!bypass)) return;
    const { user } = this.props;
    this.setState({ loading: true });

    // query will depend upon user type login
    const query = this.props.user.loggedInUser.Partner_Authority__c !== null ? 
        `SELECT Application__r.Name, Application__r.Applicant_Name__c, Full_Name__c, Application__r.Date_of_Application__c, Application_Status__c, Id, Application__c, Criteria_Indicator_2__c  FROM Person__c
        WHERE Applying_to__c = '${this.props.user.loggedInUser.Account.Id}' and RecordType.Name = 'Beneficiary'`
        : `SELECT Application__r.Name, Application__r.Applicant_Name__c,
        Full_Name__c, Application__r.Date_of_Application__c, Application_Status__c, Id, Application__c, Criteria_Indicator_2__c 
        FROM Person__c WHERE  Application__r.Related_Account__c = '${this.props.user.loggedInUser.Account.Id}'
        and RecordType.Name = 'Beneficiary' and Application_Status__c NOT 'Deleted By Partner'
        `;
    try {
        // changes in where condition Applying_to__c to Related_Account__c which is reletd householder accounts in query.
        console.log('fetching')
        const result = await fetchQueryData(`${query} Order by Application__r.Date_of_Application__c DESC`, user.siteToken.hash, user.key);
        // this.setState({ applicationList: result.records, loading: false });
        const filteredDeleted = result.records.filter(x => x.Application_Status__c !== 'Deleted By Partner')
        this.setState({ applicationList: [...filteredDeleted]});
        
        const draftList = await getApplicationDraftList.bind(this)()
        this.setState({ applicationList: [...filteredDeleted, ...draftList], loading: false });

    } catch (error) {
        console.info(error)
    }finally{
        this.setState({loading:false})
    }
}

/**
 * This function need to be bind with main component
 * return Promise JSON
 */
export async function updateApplication() {
    if (this.state.loading) return;
    try {
        this.setState({ loading: true });
        const {
            Id,
            Postal__c,
            Street__c,
            Block__c,
            Unit_Number__c,
            Flat_Type__c,
            Other_Flat_type__c,
            Ttl_Mthly_Gross_Income_Manual_Entry__c,
            Ttl_no_of_Household_mbr_Manual_Entry__c,
            Total_Monthly_Gross_Income__c,
            Total_number_of_household_members__c
        } = this.state.appDetail;
        const partnerIsSchool = this.props.user.loggedInUser.Account.Partner_Type__c === 'School';
        const dataToUpdate = {
            Postal__c,
            Street__c,
            Block__c,
            Unit_Number__c,
            Flat_Type__c,
            Other_Flat_type__c,
            Id,
        };

        if (partnerIsSchool) {
            dataToUpdate.Ttl_Mthly_Gross_Income_Manual_Entry__c = Ttl_Mthly_Gross_Income_Manual_Entry__c;
            dataToUpdate.Ttl_no_of_Household_mbr_Manual_Entry__c = Ttl_no_of_Household_mbr_Manual_Entry__c;
        }
        const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Application__c`, {
            headers: {
                'Content-Type': 'application/json',
                'hash-token': this.props.user.siteToken.hash,
            },
            method: 'PATCH',
            body: JSON.stringify(dataToUpdate),
        }).then(res => res.json());
        swal({
            text: result.message,
            title: 'Updating Application',
            type: 'success',
        });
    } catch (err) {
        swal({
            text: err.message,
            title: 'Updating Application',
            type: 'error',
        });
    } finally {
        this.setState({ loading: false, edit: false });
    }
}


/**
 * This function need to be bind with main component
 * return Promise JSON
 */


export function getApplicationPersonList(applicationId, accountId, type = 'Beneficiary', siteToken, publicKey) {
    let query = `Select Id, Name, Full_Name__c, ID_Number__c, Current_School__r.Name,
        Current_Level__c, Application_Status__c from Person__c
        Where RecordType.Name = '${type}' AND Application__c = '${applicationId}'`;
    if (type === 'Beneficiary') {
        query += ` AND Applying_to__c = '${accountId}'`;
    }
    return fetchQueryData(query, siteToken, publicKey);
}

export function getApplicationBeneList(accountId, siteToken, publicKey) {
    const query = `Select Id,  Contact_Name__r.Name, Race__c,
    Application__r.Applicant_Name__c,RecordType.Name, Application_Status__c
    FROM Person__c WHERE Contact_Name__c <> null and Application__r.Related_Account__c = '${accountId}'  and RecordType.Name = 'Beneficiary'`;
    return fetchQueryData(query, siteToken, publicKey);
}


/**
 * Get Application Attachment
 */

export function getAllAttachment(beneListIds = [], siteToken, publicKey) {
    if (beneListIds.length < 0) return {};
    const query = `Select Id, Name, Body, BodyLength, ContentType, Description From Attachment
        Where ParentId in ('${beneListIds.join("','")}')`;
    return fetchQueryData(query, siteToken, publicKey);
}

export function saveAttachment(attachment, siteToken) {
    return fetch(`${spmfcloudFunctionUrl}/attachment`, {
        mode: 'cors',
        body: JSON.stringify({
            attachment,
        }),
        cache: 'no-cache',
        method: 'POST',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    }).then(async (res) => {
        const json = await res.json();
        if (res.ok) return json;
        if (res.status === 413) throw new Error('File is too big, only 10mb is allowed');
        throw new Error(json.message);
    }).catch(error => console.log(error));
}

/**
 * this method neeed to be bind with main components
 * return Fetch <Promise> */
 export async function massUpdate(type) { //update person status
    try {
        const { siteToken } = this.props.user;
        const { checkedIds, applicationList } = this.state;
        this.setState({ loading: true });
        swal({
            text: 'Please wait for few seconds',
            title: 'Verifying Applications',
            type: 'info',
        });
        // return
        const data = checkedIds.map(obj => ({
            Id: obj,
            Application_Status__c: type,
        }));

        // Compose a list of checked application's number
        const appList = applicationList.filter(app1 => checkedIds.includes(app1.Id)).map(app2 => ({
            Name: app2.Application__r.Name,
            Id: app2.Application__c,
        }));

        const sendRequest = async (params, idx) => {
            console.log("params and ids ",JSON.stringify(params) + ' ' + idx);
            console.log("applist",appList);
                const response = await fetch(`${spmfcloudFunctionUrl}/mass-update-person-status`, {
                    mode: 'cors',
                    body: JSON.stringify({
                        data: params,
                        appList: appList[idx],
                    }),
                    cache: 'no-cache',
                    method: 'PATCH',
                    headers: {
                        'hash-token': siteToken.hash,
                        'Content-Type': 'application/json',
                    },
                });
                const json = await response.json();
                if (!response.ok) throw new Error(json.message);
                return json;
            
        };
        // const promises = []

        await data.reduce(async (p, values, index) => {
            return p.then( () => {
                return sendRequest(values, index);
            })
        }, Promise.resolve())

        // data.forEach(async (payload, index, array) => {
        //     promises.push(sendRequest(payload, index))
        // });

        // await Promise.all(promises)

        swal({
            text: 'All checked application successfully updated',
            title: 'Mass update applications',
            type: 'success',
        });
        this.setState({ loading: false, checkedIds: [] });
        this.componentWillMount();
    } catch (error) {
        console.log(error)
        swal({
            html: `<div class="error-alert">Failed to update application.<br>${error.toString()}</div>`,
            title: 'Mass update applications',
            type: 'error',
            width: '50rem',
        });
        this.setState({ loading: false, checkedIds: [] });
    }
}

export async function sendEmail() {
    try{
        
        const { user } = this.props;
        this.setState({ loading: true });
        const query = `select Id, name, email from Contact where AccountId = '${this.props.user.loggedInUser.Account.Id}' and Partner_Authority__c = 'Approver' and Active__c = true`;
        console.log("query to send email ",query);
        const resp = await fetchQueryData(query, user.siteToken.hash, user.key);
        const getEmail = resp.records.map((record)=>{
            return {email:record.Email,name:record.Name}
        });
       
        if(getEmail.length > 0)
        {
            const data = {
                "to": getEmail,
                "subject": "STSPMF Verified applications ready for your Approval",
                "text": "Test from spmf",
                "html": "<p>Dear {{name}},</p><p>This is to inform you that the applications submitted have been successfully verified and are now ready for your review and approval.</p><p>Please log in to the portal using the link below to access the applications and take the necessary action:</p><p><a href='https://portal.spmf.org.sg/' target='_blank'>https://portal.spmf.org.sg/</a></p>"
              }
            const result = await sendMails(data,user.siteToken.hash)
            console.log(`result to send on emails on ${getEmail}`,result)
            this.setState({ loading: false });
            swal({
                text: result.message,
                title: 'Success',
                type: 'success',
            });
        }
        else{
            this.setState({ loading: false });
            swal({
                text: 'Email notification was not sent out. No Approver assigned to your school/agency account. Please add at least 1 approver to proceed.',
                title: 'Error',
                type: 'error',
            });
        } 
        
        
        // console.log(emailData, "data", data)
        // if(data){
        //     return(
        //         <EmailTemplate data={emailData} />)
        // }
    }catch(error){
     
        this.setState({ loading: false });
        swal({
            text: error.message,
            title: 'Sending Email',
            type: 'error',
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Application/actions.js
// module id = 97
// module chunks = 0